module.exports = __webpack_public_path__ + "img/bitter.78fccac5.png";